import React from "react";


// Checkbox component props
interface CheckboxProps {
  checked: boolean; // Whether the checkbox is checked
  onChange: (checked: boolean) => void; // Function to handle checkbox change
  label?: string; // Optional label for the checkbox
  className?: string; // Optional CSS class for styling
}

const Checkbox: React.FC<CheckboxProps> = ({ checked, onChange, label, className }) => {
  return (
    <label className="d-flex align-items-center">
      <input
        type="checkbox"
        checked={checked}
        className={`me-2 ${className}`} 
        onChange={(e) => onChange(e.target.checked)}
      />
      {label && <span>{label}</span>}
    </label>
  );
};
export default Checkbox